import React from 'react'

const ErrorMessage = (props) => {
    return (
        <div>
            <p style={{color: 'red'}}>{props.errorMsg}</p>
        </div>
    )
}

export default ErrorMessage
